module.exports = __webpack_public_path__ + "static/media/takethestage2.716be837.jpg";